/**
 * Utilitários para o módulo de agendamento online
 * 
 * @version 1.0.0
 * RELEASE: 2026-02-20 v1.0.0 - Função stripTemplateVariables
 */

/**
 * Remove variáveis de template {{...}} do título para exibição.
 * As variáveis são interpoladas somente no momento do booking
 * (via RPC create_scheduling_booking).
 * 
 * Exemplo: "Apresentação {{nome_completo}}" → "Apresentação"
 * 
 * @param title - Título do event type (pode conter placeholders)
 * @returns Título limpo sem variáveis de template
 */
export function stripTemplateVariables(title: string): string {
  return title.replace(/\{\{[^}]*\}\}/g, '').replace(/\s{2,}/g, ' ').trim();
}
